// How-to guide navigation: sections and previous/next. Pure, so it's tested in client/test.

export type Guide = { title: string, link: string, audience: string, summary: string };

/** The guides grouped by section (audience), in reading order. */
export const sectionsOf = (guides: Guide[]) =>
    Array.from(new Set(guides.map(g => g.audience))).map(audience => ({ audience, guides: guides.filter(g => g.audience === audience) }));

/**
 * Where a guide sits: its section, its place in it, and the guides before and after it. Previous/next stay within the
 * section; past either end they step into the neighbouring section, labelled with it, so reading never dead-ends.
 */
export const guidePosition = (guides: Guide[], link: string) => {
    const sections = sectionsOf(guides);
    const sectionIndex = sections.findIndex(s => s.guides.some(g => g.link === link));
    if (sectionIndex < 0) {
        return null;
    }
    const section = sections[sectionIndex];
    const index = section.guides.findIndex(g => g.link === link);
    const prev = index > 0 ? section.guides[index - 1] : sections[sectionIndex - 1]?.guides.slice(-1)[0];
    const next = index < section.guides.length - 1 ? section.guides[index + 1] : sections[sectionIndex + 1]?.guides[0];
    return { section: section.audience, index, count: section.guides.length, prev, next };
};
